export {
  ModelStatus,
  isModelStatus,
  getModelStatuses,
  getModelStatusDisplayValue,
};

type ModelStatus = "AUTO" | "MANUAL";

const modelStatusKeys: ModelStatus[] = ["AUTO", "MANUAL"];

const isModelStatus = (value: string): value is ModelStatus => {
  return modelStatusKeys.indexOf(value as ModelStatus) > -1;
};

const getModelStatuses = () => {
  return [...modelStatusKeys];
};

const getModelStatusDisplayValue = (key: ModelStatus): string => {
  switch (key) {
    case "AUTO": {
      return "Auto";
    }
    case "MANUAL": {
      return "Manual";
    }
    default: {
      throw new Error(`ModelStatus ${key} Is Not Valid`);
    }
  }
};
